// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

import {type Anatomy, createAnatomy} from "@qualcomm-ui/utils/anatomy"

const parts = ["description", "startIcon"] as const

export const qdsMenuAnatomy: Anatomy<"menu", (typeof parts)[number]> =
  createAnatomy("menu").parts(...parts)
